import React from "react";
import error from "../assets/error4041.png";
const NotFound = () => {
  return (
    <div
      className="widthContainer"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "4",
        position: "relative",
      }}
    >
      <img style={{ height: "80vh" }} src={error} alt="Error" />
      <h2 style={{ position: "absolute", top: "20px" }}>
        Uh oh! Nothing to see here. Sorry!
      </h2>
    </div>
  );
};

export default NotFound;
